module.exports = __webpack_public_path__ + "static/img-6977033d9de09d02a92b22eacf8929ee.jpeg";